
namespace SorAraBul.PropertyManagement {

    import fld = PropertiesRow.Fields;

    @Serenity.Decorators.registerClass()
    export class PropertiesGrid extends Serenity.EntityGrid<PropertiesRow, any> {
        protected getColumnsKey() { return PropertiesColumns.columnsKey; }
        protected getDialogType() { return PropertiesDialog; }
        protected getIdProperty() { return PropertiesRow.idProperty; }
        protected getInsertPermission() { return PropertiesRow.insertPermission; }
        protected getLocalTextPrefix() { return PropertiesRow.localTextPrefix; }
        protected getService() { return PropertiesService.baseUrl; }

        private portfolioSummary: JQuery;
        private activeTypeFilter: PropertyTypes;

        constructor(container: JQuery) {
            super(container);
            this.element.addClass('property-portfolio-grid');
            this.createPortfolioSummary();
        }

        protected getSlickOptions(): Slick.GridOptions {
            var opt = super.getSlickOptions();
            opt.rowHeight = 50;
            return opt;
        }

        protected onViewSubmit() {
            if (!super.onViewSubmit())
                return false;

            this.view.params.EqualityFilter = this.view.params.EqualityFilter || {};

            if (this.activeTypeFilter != null)
                this.view.params.EqualityFilter[fld.PropertyType] = this.activeTypeFilter;
            else
                delete this.view.params.EqualityFilter[fld.PropertyType];

            return true;
        }

        protected onViewProcessData(response: Serenity.ListResponse<PropertiesRow>) {
            response = super.onViewProcessData(response);
            this.updatePortfolioSummary(response.Entities || [], response.TotalCount || 0);
            return response;
        }

        protected getColumns(): Slick.Column[] {
            var columns = super.getColumns();

            var c_property = Q.first(columns, x => x.field == fld.PropertyFullName);
            if (c_property) {
                c_property.name = 'Varlık';
                c_property.cssClass = Q.trimToNull((c_property.cssClass || '') + ' col-property-asset');
                c_property.format = ctx => this.formatPropertyCell(ctx.item);
            }

            var c_type = Q.first(columns, x => x.field == fld.PropertyType);
            if (c_type) {
                c_type.name = 'Tip';
                c_type.cssClass = Q.trimToNull((c_type.cssClass || '') + ' col-property-type');
                c_type.format = ctx => this.formatType(ctx.value);
            }

            var c_location = Q.first(columns, x => x.field == fld.PropertyLocation);
            if (c_location) {
                c_location.cssClass = Q.trimToNull((c_location.cssClass || '') + ' col-property-location');
                c_location.format = ctx => this.formatLocation(ctx.value);
            }

            var c_address = Q.first(columns, x => x.field == fld.Address);
            if (c_address) {
                c_address.cssClass = Q.trimToNull((c_address.cssClass || '') + ' col-property-address');
                c_address.format = ctx => this.formatAddress(ctx.value);
            }

            var c_rent = Q.first(columns, x => x.field == fld.RequestedRentAmountWithCurrency);
            if (c_rent) {
                c_rent.name = 'Kira';
                c_rent.cssClass = Q.trimToNull((c_rent.cssClass || '') + ' col-property-rent');
                c_rent.format = ctx => this.formatRent(ctx.value);
            }

            var c_action = Q.first(columns, x => x.field == 'PropertyAction');
            if (c_action) {
                c_action.name = 'Aksiyon';
                c_action.cssClass = Q.trimToNull((c_action.cssClass || '') + ' col-property-action');
                c_action.format = ctx => this.formatAction(ctx.item);
            }

            return columns;
        }

        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);

            if (e.isDefaultPrevented())
                return;

            var item = this.itemAt(row);
            var target = $(e.target);

            if (target.parent().hasClass('property-row-action'))
                target = target.parent();

            if (target.hasClass('property-row-action')) {
                e.preventDefault();

                if (target.hasClass('property-row-action-edit')) {
                    this.editItem(item.Id);
                    return;
                }

                if (target.hasClass('property-row-action-tenant-add')) {
                    new PropertyTenantsDialog().loadEntityAndOpenDialog({ PropertyId: item.Id });
                    return;
                }

            }
        }

        private createPortfolioSummary() {
            this.portfolioSummary = $(`
                <div class="property-summary-panel">
                    <div class="property-summary-cards">
                        <div class="property-summary-card property-total"><span class="property-summary-icon"><i class="fa fa-building"></i></span><span class="property-summary-label">Toplam Varlık</span><strong data-metric="total">0</strong></div>
                        <div class="property-summary-card property-home"><span class="property-summary-icon"><i class="fa fa-home"></i></span><span class="property-summary-label">Ev</span><strong data-metric="home">0</strong></div>
                        <div class="property-summary-card property-shop"><span class="property-summary-icon"><i class="fa fa-shopping-bag"></i></span><span class="property-summary-label">Dükkan</span><strong data-metric="shop">0</strong></div>
                        <div class="property-summary-card property-office"><span class="property-summary-icon"><i class="fa fa-briefcase"></i></span><span class="property-summary-label">Ofis</span><strong data-metric="office">0</strong></div>
                    </div>
                    <div class="property-type-chips">
                        <button type="button" class="property-type-chip active" data-type="">Tümü</button>
                        <button type="button" class="property-type-chip" data-type="${PropertyTypes.ev}">Ev</button>
                        <button type="button" class="property-type-chip" data-type="${PropertyTypes.dukkan}">Dükkan</button>
                        <button type="button" class="property-type-chip" data-type="${PropertyTypes.ofis}">Ofis</button>
                    </div>
                </div>`);

            this.portfolioSummary.on('click', '.property-type-chip', e => {
                var button = $(e.currentTarget);
                var type = Q.trimToNull(button.attr('data-type'));

                this.activeTypeFilter = type == null ? null : parseInt(type, 10) as PropertyTypes;
                this.portfolioSummary.find('.property-type-chip').removeClass('active');
                button.addClass('active');
                this.refresh();
            });

            var title = this.element.find('.grid-title');
            if (title.length)
                this.portfolioSummary.insertAfter(title);
            else
                this.element.prepend(this.portfolioSummary);
        }

        private updatePortfolioSummary(items: PropertiesRow[], totalCount: number) {
            if (!this.portfolioSummary)
                return;

            var homeCount = 0;
            var shopCount = 0;
            var officeCount = 0;

            for (var item of items) {
                if (item.PropertyType == PropertyTypes.ev)
                    homeCount++;
                else if (item.PropertyType == PropertyTypes.dukkan)
                    shopCount++;
                else if (item.PropertyType == PropertyTypes.ofis)
                    officeCount++;
            }

            this.portfolioSummary.find('[data-metric=total]').text(totalCount || items.length);
            this.portfolioSummary.find('[data-metric=home]').text(homeCount);
            this.portfolioSummary.find('[data-metric=shop]').text(shopCount);
            this.portfolioSummary.find('[data-metric=office]').text(officeCount);
        }

        private formatPropertyCell(item: PropertiesRow): string {
            var name = Q.htmlEncode(Q.coalesce(item.PropertyName, '').trim() || '-');
            var code = Q.htmlEncode(Q.coalesce(item.Code, ''));
            return `<div class="property-asset-cell"><strong>${name}</strong><span>${code}</span></div>`;
        }

        private formatType(type: PropertyTypes): string {
            var text = Serenity.EnumFormatter.format(PropertyTypes, type);
            var css = 'property-type-badge';
            var icon = 'fa fa-building';

            if (type == PropertyTypes.ev) {
                css += ' property-type-home';
                icon = 'fa fa-home';
            }
            else if (type == PropertyTypes.dukkan) {
                css += ' property-type-shop';
                icon = 'fa fa-shopping-bag';
            }
            else if (type == PropertyTypes.ofis) {
                css += ' property-type-office';
                icon = 'fa fa-briefcase';
            }

            return `<span class="${css}"><i class="${icon}"></i>${Q.htmlEncode(text)}</span>`;
        }

        private formatLocation(value: string): string {
            var text = Q.htmlEncode(Q.coalesce(value, '-'));
            return `<div class="property-location-cell" title="${Q.attrEncode(value || '')}">${text}</div>`;
        }

        private formatAddress(value: string): string {
            var text = Q.htmlEncode(Q.coalesce(value, '-'));
            return `<div class="property-address-cell" title="${Q.attrEncode(value || '')}">${text}</div>`;
        }

        private formatRent(value: string): string {
            return `<div class="property-rent-cell">${Q.htmlEncode(Q.coalesce(value, '-'))}</div>`;
        }

        private formatAction(item: PropertiesRow): string {
            return `<div class="property-action-group">
                <a href="javascript:;" class="property-row-action property-row-action-edit" title="Varlığı düzenle"><i class="fa fa-pencil"></i></a>
                <a href="javascript:;" class="property-row-action property-row-action-tenant-add" title="Kiracı ekle"><i class="fa fa-user-plus"></i><span>Kiracı Ekle</span></a>
            </div>`;
        }
    }
}
